var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHowToVoteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#1f1f1f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M219-121q-24.44 0-40.97-16.53-16.53-16.53-16.53-40.97v-113l133-150 18.5 18-127.5 145H775l-125.5-143 18-18 131 148v113q0 24.44-16.53 40.97Q765.44-121 741-121H219Zm0-25.5h522q13 0 22.5-9.5t9.5-22.5V-253H187v74.5q0 13 9.5 22.5t22.5 9.5Zm222-262-115-117q-17.5-17.5-16.75-41t18.25-41L498-778q17.11-17.12 40.05-17.06Q561-795 578.5-778l116 116q17 17.5 16.75 40.5t-17.25 40L521.5-409q-17.5 17.5-40.25 17.75T441-408.5Zm234-191q8-8 8-22.75t-8-23.25l-114-114q-8-8-23-8t-23 8l-170.5 171q-8.5 8-8.5 23t8.5 23l114 114q8 8 22.75 8t23.25-8l170.5-171Zm-488 453V-253v106.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToVoteIcon);
export default __webpack_public_path__ + "static/media/HowToVoteIcon.1ee2f92bbfd3f2215b73d6db1ff694f2.svg";
export { ForwardRef as ReactComponent };